var map = {
	"./modules/activity/activity.module": [
		"./src/app/modules/activity/activity.module.ts"
	],
	"./modules/artifacts/artifacts.module": [
		"./src/app/modules/artifacts/artifacts.module.ts"
	],
	"./modules/card/card.module": [
		"./src/app/modules/card/card.module.ts"
	],
	"./modules/inbox/inbox.module": [
		"./src/app/modules/inbox/inbox.module.ts",
		"modules-inbox-inbox-module"
	],
	"./modules/roster/roster.module": [
		"./src/app/modules/roster/roster.module.ts"
	],
	"./modules/settings/settings.module": [
		"./src/app/modules/settings/settings.module.ts"
	],
	"./modules/showcase/showcase.module": [
		"./src/app/modules/showcase/showcase.module.ts"
	],
	"./modules/user/user.module": [
		"./src/app/modules/user/user.module.ts",
		"modules-user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;